import styled from "styled-components"
import multiLineEllipsis from "@irati/ui/src/global/css/multiLineEllipsis"
import {greys} from "@irati/ui/src/global/colors"
import {Label} from "@irati/ui/src/Typography"

export default styled(Label)`
  display: block;
  margin: 0;
  ${(props) => !props.lowercase && "text-transform: capitalize;"}
  ${(props) => props.deactivated && `color: ${greys.mediumDark};`}
  ${multiLineEllipsis(1)};
`
